document.addEventListener("DOMContentLoaded", function () {
  const special = document.querySelector(".custom-special-page[data-match-with]");
  const match = document.querySelector(".custom_match_itWith[data-match-with]");

  if (special) {
    const extraPadding = parseInt(special.dataset.extraPadding) || 0;
    if (!match) {
      special.style.paddingBottom = `${extraPadding}px`;
    } else {
      special.style.paddingBottom = "";
    }
  }
});
